<template>
  <div class="activity-home">
    <!-- banner -->
    <sbanner />
    <div class="container">
      <select-box>
        <select-colum :index="1" :filterName="'地区'" :childItem="filterAreaList" v-model="filterAreaIndex"
          @change="filterAreaChange" />
        <select-colum :index="2" :filterName="'分类标签'" :childItem="filterCategoryTagsList"
          v-model="filterCategoryTagsIndex" @change="filterCategoryTagsChange" />
      </select-box>

      <div style="min-height:50vh">
        <div class="hd-list">

          <div class="sec-list flex">
            <div class="list-select flex-bd visible">
              <div class="list-select-part flex">
                <select-pop-btn :index="yearIndex" v-model="task_year" :selectCondition="yearCondition"
                  @clickItem="onChangeYears" />
                <div class="selectBtn tags areaTag" v-if="filterAreaValue && filterAreaValue.name">
                  {{ filterAreaValue.name }}
                  <i class="iconfont icon-close-fill" @click="clearFilter('area')" />
                </div>
                <div class="selectBtn tags areaTag" v-if="filterCategoryTagsValue && filterCategoryTagsValue.name">
                  {{ filterCategoryTagsValue.name }}
                  <i class="iconfont icon-close-fill" @click="clearFilter('tags')" />
                </div>
              </div>
            </div>
            <div class="totalNums">共 {{ listTotal }} 海报</div>
          </div>

          <WaterfallPage v-if="list && list.length > 0" :imageData="list" @toDetails="gotoDetails" @loadMore="loadMore" />
          <empty v-if="(!list || !list.length) && !showLoading">
            <template v-slot:emptyTips>
              <div class="empty-txt">没有更多了</div>
            </template>
          </empty>
        </div>

        <loading v-if="showLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import sbanner from "@/components/sbanner.vue"
import SelectPannel from "@/components/selectModel/commonFilter.vue"
import ActivityItem from "@/components/listModel/activityItem.vue"
import area from "@/config/area.js"
import Empty from "@/components/common/empty.vue"
import loading from "@/components/common/loading.vue"
import SelectBox from "@/components/selectSimple/select-box.vue"
import SelectColum from "@/components/selectSimple/select-colum"
import SelectPopBtn from '@/components/common/selectPopBtn2.vue'
import WaterfallPage from './components/WaterfallPage'

import mixin from "@/mixin";

export default {
  mixins: [
    mixin.changeUrl
  ],
  props: {
    msg: String
  },
  components: {
    WaterfallPage,
    sbanner,
    SelectPannel,
    ActivityItem,
    Empty,
    loading,
    SelectBox,
    SelectColum,
    SelectPopBtn
  },
  computed: {
    ...mapState({
      posterCate: state => state.posterCate
    }),
  },
  data() {
    return {
      listTotal: 0,
      pageIndex: 1,
      pageSize: 12,
      list: [],
      showLoading: false,
      filterAreaList: [],
      filterAreaValue: {},
      filterAreaIndex: 0,
      filterCategoryTagsList: [],
      filterCategoryTagsValue: {},
      filterCategoryTagsIndex: 0,
      yearCondition: {
        defaultName: "全部年份",
        type: "year",
        dropList: []
      },
      yearIndex: 0,
      task_year: '',
    };
  },
  async mounted() {
    this.initPage();
  },
  methods: {
    async initPage() {
      this.getFilterAreaList(); // 获得地区
      await this.getCategoryTags(); // 获得分类标签

      //处理query 中筛选的数据
      const { city, tag, task_year } = this.$route.query;
      if (city) {
        this.filterAreaIndex = this.filterAreaList.findIndex(v => v.id == city);
        this.filterAreaValue = this.filterAreaList[this.filterAreaIndex] || {}
      }
      if (tag && tag != -1) {
        this.filterCategoryTagsIndex = this.filterCategoryTagsList.findIndex(v => v.id == tag);
        this.filterCategoryTagsValue = this.filterCategoryTagsList[this.filterCategoryTagsIndex] || {}
      }
      if (task_year) {
        this.task_year = task_year
      }

      this.$nextTick(() => {
        this.getYearSelect(); //获取筛选年份
        this.getList()
      })
      this.$api.recordApi.addListRecord('海报');
    },
    //获取筛选的年份
    async getYearSelect() {
      let params = {
        categoryid: 3,
        typeid: -1
      };
      let minYearObj = await this.$api.yearApi.getMinYear(params);
      let minYear = parseInt(minYearObj.data);
      let yearsCode = this.$utils.getBetweenYear(minYear);
      yearsCode.unshift("全部年份");
      this.yearCondition = {
        type: "year",
        defaultName: "全部年份",
        dropList: yearsCode
      };

      if (this.task_year) {
        const yearList = this.yearCondition.dropList || []
        const yearIndex = yearList.findIndex(v => v == this.task_year)
        this.yearIndex = yearIndex == -1 ? 0 : yearIndex
      }
    },
    getFilterAreaList() {
      this.filterAreaList = area.gdData2.map(item => {
        return {
          name: item.name,
          id: item.name == "全部地区" ? "" : item.name
        };
      });
    },
    async getCategoryTags() {
      if (this.posterCate && this.posterCate.length) {
        this.filterCategoryTagsList = this.posterCate
      } else {
        await this.getPosterCate()
        setTimeout(() => {
          this.getCategoryTags()
        }, 100)
      }
    },
    //下拉选择返回数据
    onChangeYears(info) {
      this.task_year = info.toString().indexOf("全部") != -1 ? "" : info;
      this.pageIndex = 1;
      this.saveState();
    },
    filterAreaChange(info) {
      if (typeof info == "object") {
        this.filterAreaValue = this.filterAreaList[info.index];
      } else {
        this.filterAreaValue = this.filterAreaList[info];
      }
      this.pageIndex = 1;
      this.saveState();
    },
    filterCategoryTagsChange(info) {
      if (typeof info == "object") {
        this.filterCategoryTagsValue = this.filterCategoryTagsList[info.index];
      } else {
        this.filterCategoryTagsValue = this.filterCategoryTagsList[info];
      }
      this.pageIndex = 1;
      this.saveState();
    },
    // 列表
    async getList() {
      this.showLoading = true;

      let params = {
        page: this.pageIndex,
        pageSize: this.pageSize,
        // type_id: this.cateid,
      };
      const city = this.filterAreaValue ? this.filterAreaValue.id : "";
      city && (params.city = city)
      const tag = this.filterCategoryTagsValue ? this.filterCategoryTagsValue.id : '';
      tag && (params.typeid = tag)
      const task_year = this.task_year || "";
      task_year && (params.task_year = task_year)

      const res = await this.$api.posterApi.getList(params)
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_lfit,w_800`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      list = this.$utils.randomList(list)

      // test image menu
      const dataList = list.map((v, i) => {
        v.index = i
        return {
          ...v,
        }
      });

      if (this.pageIndex === 1) {
        this.list = [...dataList];
      } else {
        this.list = this.list.concat(dataList);
      }

      this.listTotal = res.total;
      const totalPage = Math.ceil(res.total / this.pageSize)
      this.hasNextPage = totalPage > this.pageIndex;
      this.showLoading = false;

    },
    clearFilter(type) {
      if (type == 'area') {
        this.filterAreaValue = {}
        this.filterAreaIndex = 0
      } else {
        this.filterCategoryTagsValue = {}
        this.filterCategoryTagsIndex = 0
      }
      this.saveState()
    },
    saveState() {
      let newP = {
        tag: this.filterCategoryTagsValue ? this.filterCategoryTagsValue.id : "",
        city: this.filterAreaValue ? this.filterAreaValue.id : "",
        task_year: this.task_year || ''
      };
      this.changeUrl(newP);
    },
    loadMore() {
      if (this.hasNextPage && !this.showLoading) {
        this.pageIndex++;
        this.getList();
      }
    },
    gotoDetails(id) {
      const path = `/poster/${id}`
      try {
        let routeLink = this.$router.resolve({
          path
        })
        window.open(routeLink.href, "_blank")
      } catch (error) {
        this.$router.push({
          path
        })
      }
    },
    ...mapActions([
      "getPosterCate"
    ]),
  }
};
</script>

<style lang="scss" scoped>
.sec-list {
  margin-bottom: 30px;
  padding-right: 30px;

  .totalNums {
    color: #6D6D6D;
  }
}

.tags {
  color: #b41717;
  border: 1px solid rgba(244, 58, 65, .1);
  background: rgba(244, 58, 65, .1);
}

.list-select-part {
  .tags {
    margin-top: 0;
  }
}
</style>